





















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component
export default class JdhBackButton extends Vue {

    @Prop() to!: Location;

    @Ref() linkEl!: HTMLElement;
    hover = false;

    startAnimation() {
        this.linkEl.classList.add('jdsc-back-button--animate');
        this.hover = true;
    }

    animationTicker() {
        if (!this.hover) {
            this.linkEl.classList.remove('jdsc-back-button--animate');
        }
    }
}
